"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("./env");
var current = {
    pathname: '/',
    visibiltyState: true
};
var router = {
    prev: null,
    current: current
};
Object.defineProperty(router, 'current', {
    get: function () {
        if (!env_1.isMiniAppPlatform) {
            return current;
        }
        return Object.assign(current, {
            pathname: window.__pageId
        });
    },
    set: function (value) {
        Object.assign(current, value);
    }
});
exports.default = router;
